export function getCurrencySymbol(currencyId) {
  switch (currencyId) {
    case 'usd':
      return '$'
    case 'eur':
      return '€'
    case 'gbp':
      return '£'
    default:
      return currencyId
  }
}
